export const categoryImages: Record<string, string> = {
  shoes: 'https://readdy.ai/api/search-image?query=White%20minimalist%20sneakers%20displayed%20on%20floating%20glass%20shelf%20with%20morning%20sunlight%20casting%20long%20shadows%2C%20clean%20cream%20wall%20background%2C%20aerial%20product%20photography%20angle%2C%20ultra%20minimal%20editorial%20style%20with%20soft%20warm%20tones&width=800&height=600&seq=cat-shoes-v2&orientation=landscape',
  hoodies: 'https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20draped%20over%20wooden%20chair%20near%20sunlit%20window%2C%20cozy%20Scandinavian%20interior%20with%20potted%20plant%2C%20soft%20golden%20hour%20light%2C%20textured%20fabric%20closeup%2C%20lifestyle%20editorial%20photography%20with%20warm%20atmosphere&width=600&height=450&seq=cat-hoodies-v2&orientation=landscape',
  tshirts: 'https://readdy.ai/api/search-image?query=Stack%20of%20perfectly%20folded%20pastel%20cotton%20t-shirts%20on%20marble%20surface%2C%20top-down%20flatlay%20view%2C%20soft%20studio%20lighting%20with%20gentle%20gradient%20background%2C%20textile%20texture%20visible%2C%20minimalist%20catalog%20photography&width=600&height=450&seq=cat-tshirts-v2&orientation=landscape',
  jackets: 'https://readdy.ai/api/search-image?query=Vintage%20leather%20jacket%20hanging%20on%20minimalist%20wall%20hook%20against%20warm%20terracotta%20painted%20wall%2C%20afternoon%20light%20from%20side%20window%2C%20textured%20leather%20details%2C%20artistic%20editorial%20photography%20with%20dramatic%20soft%20shadows&width=600&height=450&seq=cat-jackets-v2&orientation=landscape',
  pants: 'https://readdy.ai/api/search-image?query=Denim%20jeans%20and%20linen%20shorts%20arranged%20in%20spiral%20pattern%20on%20light%20oak%20floor%2C%20top-down%20creative%20flatlay%2C%20natural%20daylight%20from%20above%2C%20textile%20textures%20contrasting%2C%20editorial%20fashion%20photography&width=600&height=450&seq=cat-pants-v2&orientation=landscape',
  headwear: 'https://readdy.ai/api/search-image?query=Collection%20of%20baseball%20caps%20and%20beanies%20in%20earth%20tones%20hanging%20on%20minimalist%20wooden%20pegs%2C%20warm%20side%20lighting%2C%20clean%20cream%20background%2C%20organized%20retail%20display%20photography%20with%20soft%20shadows&width=600&height=450&seq=cat-headwear-v2&orientation=landscape',
  sets: 'https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20outfit%20set%20displayed%20on%20transparent%20mannequin%20against%20architectural%20concrete%20wall%2C%20soft%20diffused%20studio%20lighting%2C%20high-end%20fashion%20editorial%20photography%20with%20elegant%20minimalist%20composition&width=600&height=450&seq=cat-sets-v2&orientation=landscape',
  underwear: 'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20underwear%20folded%20neatly%20inside%20open%20drawer%20with%20lavender%20sprigs%2C%20soft%20morning%20light%2C%20cozy%20bedroom%20aesthetic%2C%20lifestyle%20product%20photography%20with%20warm%20intimate%20atmosphere&width=600&height=450&seq=cat-underwear-v2&orientation=landscape',
  jersey: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20on%20stadium%20seat%20with%20golden%20sunset%20backlight%2C%20dramatic%20atmospheric%20lighting%2C%20sportswear%20editorial%20photography%20with%20heroic%20composition%20and%20warm%20tones&width=600&height=450&seq=cat-jersey-v2&orientation=landscape',
  accessories: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20jewelry%20and%20sunglasses%20scattered%20on%20white%20travertine%20stone%20surface%2C%20top-down%20creative%20flatlay%2C%20golden%20hour%20sunlight%2C%20luxury%20editorial%20photography%20with%20warm%20reflections%20and%20organic%20shadows&width=600&height=450&seq=cat-accessories-v2&orientation=landscape',
  bags: 'https://readdy.ai/api/search-image?query=Designer%20tote%20bag%20and%20leather%20backpack%20placed%20on%20minimalist%20bench%20in%20sunlit%20hallway%2C%20architectural%20shadows%20from%20window%20blinds%2C%20sophisticated%20editorial%20photography%20with%20warm%20neutral%20color%20palette&width=600&height=450&seq=cat-bags-v2&orientation=landscape',
  belts: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20rolled%20and%20displayed%20on%20rustic%20wooden%20table%2C%20candlelight%20warm%20ambiance%2C%20artisan%20workshop%20aesthetic%2C%20product%20photography%20with%20rich%20textures%20and%20golden%20warm%20lighting&width=600&height=450&seq=cat-belts-v2&orientation=landscape',
  perfumes: 'https://readdy.ai/api/search-image?query=Luxury%20fragrance%20bottles%20on%20mirrored%20surface%20with%20fresh%20flowers%2C%20soft%20backlit%20window%20light%20creating%20ethereal%20glow%2C%20elegant%20beauty%20editorial%20photography%20with%20romantic%20warm%20atmosphere%20and%20delicate%20composition&width=600&height=450&seq=cat-perfumes-v2&orientation=landscape',
  other: 'https://readdy.ai/api/search-image?query=Eclectic%20collection%20of%20fashion%20accessories%20and%20lifestyle%20items%20on%20colorful%20Moroccan%20tile%20table%2C%20bright%20afternoon%20sunlight%2C%20bohemian%20editorial%20photography%20with%20vibrant%20warm%20colors%20and%20artistic%20composition&width=600&height=450&seq=cat-other-v2&orientation=landscape',
};

export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Calçados',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    accent: true,
  },
  {
    id: 'hoodies',
    name: 'Hoodies / Sweaters',
    namePt: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    accent: false,
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    accent: false,
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jaquetas',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    accent: false,
  },
  {
    id: 'pants',
    name: 'Pants / Shorts',
    namePt: 'Calças / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    accent: false,
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Chapéus / Acessórios',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    accent: false,
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Conjuntos',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    accent: false,
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    namePt: 'Roupa Íntima',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    accent: false,
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    accent: false,
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Acessórios',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    accent: false,
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bolsas',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    accent: false,
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Cintos',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    accent: false,
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    accent: false,
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Outros Itens',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    accent: false,
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';